import { render } from "./SearchCourseByTextContent.vue?vue&type=template&id=51ba6345&scoped=true"
import script from "./SearchCourseByTextContent.vue?vue&type=script&lang=js"
export * from "./SearchCourseByTextContent.vue?vue&type=script&lang=js"

import "./SearchCourseByTextContent.vue?vue&type=style&index=0&id=51ba6345&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51ba6345"]])

export default __exports__